import { Button, Tooltip } from "@blueprintjs/core"
import { AxiosError } from "axios"
import { useEffect, useState } from "react"

import { createToaster } from "../../../../utils/createToaster"
import useRefreshTradingData from "../hooks/useRefreshTradingData"

interface IRefreshButtonProps {
  lastUpdatedAt?: string | null
}

export const RefreshButton = ({ lastUpdatedAt }: IRefreshButtonProps) => {
  const [refreshInitiatedAt, setRefreshInitiatedAt] = useState<string | null>(null)

  const { mutate, isLoading } = useRefreshTradingData({
    onSuccess: () => {
      setRefreshInitiatedAt(lastUpdatedAt || null)
    },
    onError: (error: AxiosError) => {
      createToaster({
        message: "Data cannot be refreshed. Please contact a Scient administrator.",
        intent: "warning",
      })
    },
  })

  const isWaitingForUpdate = refreshInitiatedAt !== null && lastUpdatedAt === refreshInitiatedAt

  useEffect(() => {
    if (refreshInitiatedAt && lastUpdatedAt !== refreshInitiatedAt) {
      setRefreshInitiatedAt(null)
    }
  }, [lastUpdatedAt, refreshInitiatedAt])

  return (
    <Tooltip content="Refresh available every 10 seconds" placement="bottom" hoverOpenDelay={1000}>
      <Button
        onClick={() => mutate()}
        disabled={isLoading || isWaitingForUpdate}
        icon="refresh"
        intent="primary"
        loading={isLoading || isWaitingForUpdate}
      />
    </Tooltip>
  )
}
